// extracted by mini-css-extract-plugin
export default {"error":"xHs86Xm","opacityIn":"v7cL119","listItemTimer":"PLSJPTd"};